export default __webpack_public_path__ + "static/media/play-button.ca726917.svg";